<template>
  <main>
    <div class="m-header" :class="[$route.name == 'Edm' ? 'edm' : '']">
      <div class="top" :class="[menu_show ? 'active' :'']">
        <div class="left logo" @click="toIndex"><img :src="logo" alt=""></div>
        <div class="right more" v-if="!$route.meta.is_out" @click="showMenu"></div>
      </div>
      <div class="menu-box" :class="[menu_show ? 'active' :'']">
        <div class="m-top"></div>
        <div class="wrap">
          <div class="user-box" v-if="!user_info.id">
            <div class="left btn login" @click="toLogin"><span>登录</span></div>
            <div class="left btn register" v-if="false" @click="toRegister"><span>报名</span></div>
          </div>
          <div class="username-box" v-if="user_info.id">
            <div class="left btn username">{{ user_info.username || "Dell用户" }}</div>
            <div class="left btn exit" @click="exitUser"><span>退出</span></div>
          </div>
          <!-- <RecursiveMenu :list="menu" :frist="true" v-if="isMenuLoading" @change="menuChange"></RecursiveMenu> -->
         <div class="menu-list">
           <div class="item" v-for="(item,index) in menu" :class="[item.min ? 'more' : '',more_show == index ? 'show' : '']">
             <div class="tit-box" @click="toMenu(item,index)">
               <div class="left tit">{{ item.title }}</div>
               <div class="right btn" v-if="item.min"></div>
             </div>
             <div class="ll" v-if="item.min">
               <div class="li" v-for="i in item.min" @click="toMenu(i)">{{ i.title }}</div>
             </div>
           </div>
         </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import RecursiveMenu from "@/components/m/Menu.vue";

export default {
  name: "top",
  data() {
    return {
      query: "",
      logo: require("@/assets/image/2025/logo.png"),
      more_show: "",
      menu_show: "",
      isMenuLoading: false,
      boothMenu: [], // 线上展区菜单（接口填充）
    };
  },
  components: {RecursiveMenu},
  computed: {
    route() {
      return this.$route;
    },
    user_info() {
      if (this.$store.state.user_info.id) {
        // // 登录用户变量
        var gioParams = {
          // area_ppl: (this.$store.state.user_info.province + this.$store.state.user_info.city) || "",//省份,城市
          // companyName_ppl: this.$store.state.user_info.company || "",//公司名称
          // companyScale_ppl: "",//公司规模
          // email_ppl: this.$store.state.user_info.email || "",//邮箱
          // industry_ppl: this.$store.state.user_info.job || "",//行业
          phone_ppl: this.util.encryptPhone(this.$store.state.user_info.mobile) || ""//手机
          // userName_ppl: this.$store.state.user_info.username || "",//姓名
          // userRole_ppl: "",//职位
        };
        gio("people.set", gioParams);
        //登录用户ID
        gio("setUserId", this.$store.state.user_info.id);
        //登录用户类型
        gio("track", "loginSuccess", {
          "user_Id": this.$store.state.user_info.memberId,  // memberId
          "phoneNumber": this.util.encryptPhone(this.$store.state.user_info.mobile), //登录手机号
          "loginType": "短信" // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
        });
      }
      return this.$store.state.user_info;
    },
    menu() {
      var _arr = [];
      // if(this.util.isOffline()){//线下
      //     _arr = [
      //         {title:"首页",link:"/"},
      //         {title:"主会场",link:"/plan"},
      //         {title:"分论坛",link:"/branch"},
      //         {title:"线下活动",link:"/offline"},
      //         {title:"线上展区",min:[{title:"未来的工作模式",link:"https://www.dellemc-solution.com/dtfbooth/2022/futureofwork"},{title:"现代数据中心和边缘",link:"https://www.dellemc-solution.com/dtfbooth/2022/moderndata"},{title:"APEX 帮助简化多云环境中的 IT",link:"https://www.dellemc-solution.com/dtfbooth/2022/apex"},{title:"安全性",link:"https://www.dellemc-solution.com/dtfbooth/2022/security"},{title:"行业解决方案",link:"https://www.dellemc-solution.com/dtfbooth/2022/indutries"},{title:"带你逛展区",link:"https://event.mudu.com/event/fpicfktiwa/watch/ow8o69"}]},
      //         // {title:"互动专区",min:[{{title:"资料下载",link:"/interact/download"}]},
      //         {title:"赞助商",link:"/contact/sponsor"},
      //         {title:"联系我们",min:[{title:"联系戴尔",link:"/contact/dell"},{title:"调查问卷",link:"/interact/paper"},{title:"社交媒体",link:"/contact/media"}]},
      // 		{title:"我的日程",link:"/ucenter/plan",auth:true,}
      //     ]
      // }else{
      //     _arr = [
      //         {title:"首页",link:"/"},
      //         {title:"主会场",link:"/plan"},
      //         {title:"分论坛",link:"/branch"},
      //         {title:"线上展区",min:[{title:"未来的工作模式",link:"https://www.dellemc-solution.com/dtfbooth/2022/futureofwork"},{title:"现代数据中心和边缘",link:"https://www.dellemc-solution.com/dtfbooth/2022/moderndata"},{title:"APEX 帮助简化多云环境中的 IT",link:"https://www.dellemc-solution.com/dtfbooth/2022/apex"},{title:"安全性",link:"https://www.dellemc-solution.com/dtfbooth/2022/security"},{title:"行业解决方案",link:"https://www.dellemc-solution.com/dtfbooth/2022/indutries"},{title:"带你逛展区",link:"https://event.mudu.com/event/fpicfktiwa/watch/ow8o69"}]},
      //         // {title:"互动专区",min:[{title:"资料下载",link:"/interact/download"}]},
      //         {title:"赞助商",link:"/contact/sponsor"},
      //         {title:"联系我们",min:[{title:"联系戴尔",link:"/contact/dell"},{title:"调查问卷",link:"/interact/paper"},{title:"社交媒体",link:"/contact/media"}]},
      // 		{title:"我的日程",link:"/ucenter/plan",auth:true,}
      //     ]
      // }
      if (this.util.isOffline()) {//线下
        _arr = [
          {title: "首页", link: "/"},
          {title: "主会场", link: "/plan" /*已放开*/},
          {title: "分论坛", link: "/branch"},
          {title: "线下活动", link: "/offline"},
          {
            title: "线上展区", min: this.boothMenu
          },
          // {
          //   title: "线上展区", min: [
          //     {title: "ESG展区", link: "https://www.dell.com/zh-cn/dt/corporate/social-impact.htm", target: "_blank"},
          //     {title: "出海展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/goglobal", target: "_blank"},
          //     {title: "服务展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/service", target: "_blank"},
          //     {title: "OEM 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/oem", target: "_blank"},
          //     {title: "行业展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/manufacture", target: "_blank"},
          //     {title: "外星人展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/alienware", target: "_blank"},
          //     {title: "CSG 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/dellpro", target: "_blank"},
          //     {title: "ISG 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/sdi-hci", target: "_blank"}
          //   ]
          // },
          // {title:"互动专区",min:[{title:"资料下载",link:"/interact/download"}]},
          {title: "赞助商", link: "/contact/sponsor" /*已放开*/},
          {
            title: "联系我们",
            min: [{title: "联系戴尔", link: "/contact/dell"}, {title: "调查问卷", link: "/interact/paper"}, {title: "社交媒体", link: "/contact/media"}]
          },
          {title: "我的日程", link: "/ucenter/plan", auth: true}
        ];
      } else {
        _arr = [
          {title: "首页", link: "/"},
          {title: "主会场", link: "/plan" /*已放开*/},
          {title: "分论坛", link: "/branch"},
          {
            title: "线上展区", min: this.boothMenu
          },
          // {
          //   title: "线上展区", min: [
          //     {title: "ESG展区", link: "https://www.dell.com/zh-cn/dt/corporate/social-impact.htm", target: "_blank"},
          //     {title: "出海展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/goglobal", target: "_blank"},
          //     {title: "服务展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/service", target: "_blank"},
          //     {title: "OEM 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/oem", target: "_blank"},
          //     {title: "行业展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/manufacture", target: "_blank"},
          //     {title: "外星人展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/alienware", target: "_blank"},
          //     {title: "CSG 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/dellpro", target: "_blank"},
          //     {title: "ISG 展区", link: "https://www.dellemc-solution.com/dtfbooth/2026/sdi-hci", target: "_blank"}
          //   ]
          // },
          // {title:"互动专区",min:[{title:"资料下载",link:"/interact/download"}]},
          {title: "赞助商", link: "/contact/sponsor" /*已放开*/},
          {
            title: "联系我们",
            min: [{title: "联系戴尔", link: "/contact/dell"}, {title: "调查问卷", link: "/interact/paper"}, {title: "社交媒体", link: "/contact/media"}]
          },
          {title: "我的日程", link: "/ucenter/plan", auth: true}
        ];
      }
      return _arr;
    },
    route_path() {
      return this.$route.path;
    }
  },
  watch: {
    route() {
      this.hideMenu();
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      // 该接口为公开的线上展区菜单，不经过 /dtf-b，且不带鉴权。
      // 用原生 fetch 发 GET 简单请求(不带自定义头)，规避 CORS 预检被拦截(Token 头不在服务端允许列表)，
      const tyle = this.util.isOffline() ? "offline" : "online";
      fetch(`https://www.dellemc-solution.com/api/dtf/booth/menu?tyle=${tyle}`, { method: "GET" })
        .then(r => r.json())
        .then(res => {
          const list = (res && res.data) || [];
          // 只取一级展区（丢弃二级 min），外链统一新开标签页
          this.boothMenu = list.map(x => ({
            title: x.title,
            link: x.link,
            target: /^https?:\/\//.test(x.link || "") ? "_blank" : ""
          }));
        })
        .catch(() => {});
    },
    toIndex() {
      if (!this.$route.meta.is_out) {
        this.util.toLink("/");
      }
    },
    toLogin() {
      this.hideMenu();
      this.util.toLink("/login", {
        from: this.$route.query.from ?
            this.$route.query.from :
            (this.$route.path == "/login" || this.$route.path == "/register") ? "/" : this.$route.fullPath
      });
    },
    toRegister() {
      gio("track", "DTF2021_hometop_signup");
      this.hideMenu();
      this.util.toLink("/register", {
        from: this.$route.query.from ?
            this.$route.query.from :
            (this.$route.path == "/login" || this.$route.path == "/register") ? "/" : this.$route.fullPath
      });
    },
    exitUser() {
      this.$router.replace({
        path: "/exit",
        query: {
          from: this.$route.fullPath
        }
      });
    },
    hideMenu() {
      this.menu_show = false;
      this.more_show = "";
    },
    showMenu() {
      if (this.menu_show) {
        this.menu_show = false;
        this.more_show = "";
      } else {
        this.menu_show = true;
      }
    },
    toMenu(item, index) {
      // 敬请期待优先级最高，带子菜单的项也拦截（原无此拦截）
      if (item.coming_soon) {
        this.$toast('敬请期待');
        return;
      }
      if (item.min) {
        this.more_show = this.more_show == index ? "" : index;
      } else {
        this.hideMenu();
        if (!item.link) {
          this.util.showWait(true);
        } else {
          if (item.auth && !this.util.getAccessToken()) {
            this.util.showAuth({
              show: true,
              from: item.link
            });
          } else {
            if (item.target && item.target == "_blank") {
              this.util.toLink(item.link, {}, "_blank");
            } else {
              this.util.toLink(item.link);
            }
          }
        }
      }
    },
    menuChange(item) {
      if (item.min) {
        // this.more_show = this.more_show == index ? "" : index;
      } else {
        this.hideMenu();
      }
    }
  },
  mounted() {
    this.query = this.$route.query;
  }
};
</script>

<style lang="scss" type="text/scss" scoped>
    .m-header{
        .top{position: fixed; height:.88rem;overflow: hidden;top:0;left:0;width:100%;border-bottom:none;z-index: 100;
            .logo{width:2.85rem;margin-left: .25rem; margin-top: .15rem;
                img{width: 100%;object-fit: contain;}
            }
            .more{width: .88rem;height:.88rem;background: url("~@/assets/image/m2.png") no-repeat center center;background-size: .38rem;}
        }
        .top.active{
            .more{width: .88rem;height:.88rem;background: url("~@/assets/image/m3.png") no-repeat center center;background-size: .38rem;}
        }
        .menu-box{position: fixed;top:0;left:0;width: 100%;height:0;display: flex;flex-direction: column;z-index: 150;transition: all .3s ease;pointer-events: none;
            .m-top{height:.88rem;padding: 0 .25rem;overflow: hidden;pointer-events: none;}
            .wrap{flex: 1;background: #fff;overflow: hidden;overflow-y: auto;pointer-events:auto;
                .user-box{height:.5rem;padding: .22rem .5rem;border-bottom: .02rem solid #eeeeee;line-height: .44rem;font-size: .27rem;
                    .btn{height: .5rem;padding: 0 .2rem; border: .02rem solid #d5d5d5;}
                    .btn.login{margin-right: .2rem;
                        span{padding-left: .4rem;background: url("~@/assets/image/88_a.png") no-repeat left center;background-size: .26rem;}
                    }
                    .btn.register{
                        span{padding-left: .4rem;background: url("~@/assets/image/87_a.png") no-repeat left center;background-size: .26rem;}
                    }
                    .btn.line{height: .44rem;padding: 0;}
                    .btn.exit{color:#5d5d5d;}
                }
                .username-box{height:.5rem;padding: .22rem .5rem;border-bottom: .02rem solid #eeeeee;line-height: .44rem;font-size: .27rem;
                    .btn.exit{margin-left: .2rem;height: .5rem;padding: 0 .2rem; border: .02rem solid #d5d5d5;
                        span{padding-left: .4rem;background: url("~@/assets/image/89_a.png") no-repeat left center;background-size: .26rem;}
                    }
                }
                .menu-list{
                    .item{
                        .tit-box{height:.88rem;padding: 0 .25rem 0 .5rem;line-height: .88rem;border-bottom: .02rem solid #eeeeee;font-size: .24rem;
                            .btn{width: .88rem;height:.88rem;background: url("~@/assets/image/2021/13.png") no-repeat right center;background-size: .22rem;transition: all .3s ease;}
                        }
                        .ll{background: #f4f4f4;padding-left: .5rem;line-height: .88rem;height: 0;transition: height .3s ease;overflow: hidden;
                            .li{height:.88rem; border-bottom: .02rem solid #eeeeee;color: #565656;font-size: .24rem;}
                            .li:nth-last-child(1){border-bottom: none;}
                        }
                    }
                    .item:nth-last-child(1){
                        .tit-box{border-bottom: none;}
                    }
                    .item.show{
                        .tit-box{
                            .btn{background-image: url("~@/assets/image/2021/12.png");background-size: .22rem;transition: all .3s ease;}
                        }
                        .ll{height:2.64rem;transition: height .3s ease;}
                    }
					.item:nth-child(4).show,.item:nth-child(5).show{
						.ll{height:7.92rem;}
					}
                    .item.more.show{
                        .tit-box{border-bottom: none;}
                    }
                }
            }
        }
        .menu-box.active{height: 100vh;transition: all .3s ease;}
    }
    .m-header.edm{
        .top{position: absolute;}
    }
</style>

